import { render, staticRenderFns } from "./DashboardStatisticChartWidget.vue?vue&type=template&id=eace1892&scoped=true"
import script from "./DashboardStatisticChartWidget.vue?vue&type=script&lang=js"
export * from "./DashboardStatisticChartWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardStatisticChartWidget.vue?vue&type=style&index=0&id=eace1892&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eace1892",
  null
  
)

export default component.exports